module.exports = __webpack_public_path__ + "img/mhl.6d60cee3.svg";